import React from 'react';
import Sky from 'react-sky';
import wowoGif from '../../imgs/wowo.gif';
import wowoGif2 from '../../imgs/wowo2.gif';

import './ContactForMore.css';

function ContactForMore() {
  return (
    <div className="contact_for_more">
      <div className="title">
        <h1>You found it!</h1>
        <a href="mailto:itsritzw@gmail.com">Contact me for more.</a>
      </div>

      <Sky
        images={{
          /* FORMAT AS FOLLOWS */
          0: wowoGif /* You can pass as many images as you want */,
          1: wowoGif2
        }}
        how={
          120
        } /* Pass the number of images Sky will render chosing randomly */
        time={60} /* time of animation */
        size="100px" /* size of the rendered images */
        // background="white"
      />
    </div>
  );
}

export default ContactForMore;



// WEBPACK FOOTER //
// ./src/Modules/ContactForMore/ContactForMore.js